import React, { FC } from 'react'

import { Txt, Icon } from 'src/components/atoms'

type Props = {
  className?: string
}

export const StoppedProjectCautionMessage: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <div className="tw-centering tw-text-errorRed-default tw-py-s-1 tw-border tw-border-errorRed-default tw-rounded-[6px] tw-bg-[rgba(255,0,92,0.06)]">
        <Icon size="--r1" path="alert-circle/soft/soft" />
        <Txt className="tw-ml-s-2">
          このプロジェクトは「停止中」のためROOV compassへはアクセスはできません。
        </Txt>
      </div>
    </div>
  )
}
